import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { formatDateTimeBR } from "../../../../../helpers/format";
import { IOperacoesPortoCarrossel } from "../types/types";

interface Props {
  data?: IOperacoesPortoCarrossel;
  title: string;
  onClose: () => void;
}

const Info: React.FC<Props> = (props: Props) => {

  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              ID
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_operacao_porto_carrossel ? props.data.id_operacao_porto_carrossel : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Terminal
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.terminal?.razao_social || '---'}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Proprietário de Carga
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.proprietarioDeCarga?.razao_social || '---'}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data Início
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_inicio_operacao ? formatDateTimeBR(props.data.data_inicio_operacao) : '---'}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data Fim
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_fim_operacao ? formatDateTimeBR(props.data.data_fim_operacao) : '---'}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Urgência
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.urgencia ? "Sim" : "Não"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Intervalo Acesso
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.intervalo_acesso_liberado_porto || '---'}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Valor Tonelada
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.valor_tonelada ? `R$ ${props.data.valor_tonelada}` : '---'}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Tonelada Prevista
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.tonelada_prevista_transportadas || '---'}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Toneladas Transportadas
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.toneladas_transportadas || '---'}
            </span>
          </div>
          
        </div>
        <div className="w-full grid grid-cols-1 gap-2 gap-y-6 mt-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Usuário
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.usuario ? props.data.usuario : '---'}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Data Modificação
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_historico ? formatDateTimeBR(props.data.data_historico) : '---'}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
